const transfers = {
  transfer: "לְהַעֲבִיר", // translated
  transfers: "העברות", // translated
  dateAndTime: "תאריך ושעה", // translated
  transferFrom: "העבר מ", // translated
  duration: "מֶשֶׁך", // translated
  numOfPersons: "מספר אנשים", // translated
  baggageAllowance: "כבודה מותרת", // translated
  small: "קָטָן", // translated
  big: "גָדוֹל", // translated
  provider: "ספק", // translated
  vehicle: "רכב", // translated
  distance: "מֶרְחָק", // translated
  price: "מחיר", // translated
  inboundJourney: "מסע נכנס", // translated
  outboundJourney: "מסע יוצא", // translated
  arrivalTime: "זמן הגעה", // translated
  flightDetails: "פרטי טיסה", // translated
  inboundPickupDate: "תאריך איסוף נכנס", // translated
  outboundPickupDate: "תאריך איסוף יוצא", // translated
  travelInfo: "מידע על נסיעות", // translated
  flightsInfo: "מידע על טיסות", // translated
  airportYouAreFlyingFrom: "שדה התעופה שממנו אתה טס", // translated
  airportYouAreFlyingTo: "שדה התעופה שאליו אתה טס", // translated
  inboundFlightNumber: "מספר טיסה נכנסת", // translated
  outboundFlightNumber: "מספר טיסה יוצאת", // translated
  inboundAirlineName: "שם חברת תעופה נכנסת", // translated
  outboundAirlineName: "שם חברת תעופה יוצאת", // translated
  tripMode: "מצב טיול", // translated
  airportToPoint: "Airport To Point", // translated
  pointToAirport: "הצבע לשדה התעופה", // translated
  roundTrip: "נסיעה הלוך ושוב", // translated
  destinationPoint: "נקודת יעד", // translated
  originPoint: "נקודת מוצא", // translated
  transferType: "סוג העברה", // translated
  min: "מינימום", // translated
  max: "מקסימום", // translated
  pieces: "חתיכות", // translated
  cancelationIs: "ביטול הוא", // translated
};

export default transfers;
